import { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import {
  studentFeeReportBatchWise,
} from "../../api/Student";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import DownloadExcel from "../master/DownloadExcel";
import { PrintPage } from "../master/Print";
import { Link } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function BatchDueFeesReport() {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState({});
  const [batchWiseData, setBatchWiseData] = useState({});
  const hasAccess = usePrivateLink();

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return { ...prev, session_id: activeSession };
    });
  }, [sessions]);

  const buildQuery = () => {
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) addUrl += `&${key}=${encodeURIComponent(value)}`;
    });
    return addUrl;
  };

  const getStudentFeeReportBatchWise = async () => {
    setLoading(true);
    try {
      const response = await studentFeeReportBatchWise(buildQuery());
      if (response.data.status) {
        setBatchWiseData(response?.data?.data || {});
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudentFeeReportBatchWise();
  }, [filters]);

  const inr = (n) =>
    "₹ " +
    Number(n || 0).toLocaleString("en-IN", {
      maximumFractionDigits: 0,
    });

  const handleDownload = async (type = "excel") => {
    setLoading(true);
    try {
      const downloadData = [
        ...(batchWiseData?.batch_wise?.map((row, index) => ({
          Batch: row.batch_title,
          Students: Number(row.students),
          "Total Fee": Number(row.total_fee),
          Discount: Number(row.total_discount),
          "Payable Fee": Number(row.final_fee),
          "Received Fee": Number(row.total_paid),
          Due: Number(row.total_due),
        })) || []),

        {
          Batch: "TOTAL",
          Students: batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.students),
            0,
          ),
          "Total Fee": batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.total_fee),
            0,
          ),
          Discount: batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.total_discount),
            0,
          ),
          "Payable Fee": batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.final_fee),
            0,
          ),
          "Received Fee": batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.total_paid),
            0,
          ),
          Due: batchWiseData?.batch_wise?.reduce(
            (t, b) => t + Number(b.total_due),
            0,
          ),
        },
      ];
      if (downloadData.length) {
        if (type === "excel") {
          const now = new Date();

          const fileName = `Report_${now.getFullYear()}_${now.getMonth() + 1
            }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

          DownloadExcel(downloadData, [], fileName, []);
        } else {
          PrintPage(downloadData);
        }
      } else {
        SweetAlertShow("info", "Info", "No records found");
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message || err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    {/* Header / Filters */}
                    <div className="card border-0 shadow-sm rounded-4 p-3 mb-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="bg-primary text-white rounded-3 d-flex align-items-center justify-content-center fs-5"
                            style={{ width: 46, height: 46 }}
                          >
                            <i className="ri-money-rupee-circle-line"></i>
                          </div>
                          <div>
                            <h5 className="m-0 fw-bold">
                              Fees Report / Dashboard
                            </h5>
                            <small className="text-muted">
                              Monitor fees collection and analytics
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div
                            className="form-floating form-floating-outline"
                            style={{ minWidth: "220px" }}
                          >
                            <select
                              className="form-select rounded-3"
                              value={filters?.session_id || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  session_id: e.target.value,
                                })
                              }
                            >
                              {sessions?.map((s) => (
                                <option key={s.id} value={s.id}>
                                  {s.session} :{" "}
                                  {s.status === "1" ? "Active" : "Inactive"}
                                </option>
                              ))}
                            </select>
                            <label>Session</label>
                          </div>

                          <div
                            className="form-floating form-floating-outline"
                            style={{ minWidth: "180px" }}
                          >
                            <select
                              className="form-select rounded-3"
                              value={filters?.rte_status || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  rte_status: e.target.value,
                                })
                              }
                            >
                              <option value="">All</option>
                              <option value="RTE">RTE</option>
                              <option value="NON-RTE">NON-RTE</option>
                            </select>
                            <label>RTE Status</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Batch-wise Report */}
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                      {/* Header */}
                      <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="rounded-3 d-flex align-items-center justify-content-center text-white"
                            style={{
                              width: 44,
                              height: 44,
                              background:
                                "linear-gradient(135deg, #10b981, #22c55e)",
                            }}
                          >
                            <i className="ri-stack-line fs-5"></i>
                          </div>

                          <div>
                            <h6 className="m-0 fw-bold">
                              Batch Wise Fee Report
                            </h6>
                            <small className="text-muted">
                              Fees summary grouped by batch
                            </small>
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <span className="badge bg-light text-dark border fw-semibold px-3 py-2 rounded-pill">
                            {batchWiseData?.batch_wise?.length || 0} Batches
                          </span>
                          {hasAccess("/fees/excel/list") && (
                            <button
                              type="button"
                              className="btn btn-outline-primary rounded-3"
                              onClick={() => handleDownload("excel")}
                            >
                              <i className="ri-file-excel-2-line me-2"></i>{" "}
                              Download
                            </button>
                          )}
                          {hasAccess(
                            "/fees/print/list",
                          ) && (
                              <button
                                type="button"
                                className="btn btn-outline-info rounded-3"
                                onClick={() => handleDownload("print")}
                              >
                                <i className="ri-printer-line me-2"></i> Print
                              </button>
                            )}
                        </div>
                      </div>

                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr className="text-uppercase small text-muted">
                              <th className="ps-4">$Batch</th>
                              <th className="text-start">Batch</th>
                              <th className="text-center">Students</th>
                              <th className="text-end">Total Fee</th>
                              <th className="text-end">Discount</th>
                              <th className="text-end">Payable Fee</th>
                              <th className="text-end">Received Fee</th>
                              <th className="text-end pe-4">Due</th>
                              <th className="text-end pe-4">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {!batchWiseData?.batch_wise?.length ? (
                              <tr>
                                <td
                                  colSpan="7"
                                  className="text-center py-5 text-muted"
                                >
                                  No data available
                                </td>
                              </tr>
                            ) : (
                              batchWiseData.batch_wise.map((row, i) => (
                                <tr key={row.batch_id}>
                                  <td className="ps-4 fw-semibold">{i + 1}</td>
                                  <td className="text-start fw-semibold">
                                    {row.batch_title}
                                  </td>

                                  <td className="text-center">
                                    <span className="badge bg-primary-subtle text-primary">
                                      {row.students}
                                    </span>
                                  </td>

                                  <td className="text-end">
                                    {inr(row.total_fee)}
                                  </td>

                                  <td className="text-end text-danger">
                                    {inr(row.total_discount)}
                                  </td>

                                  <td className="text-end">
                                    {inr(row.final_fee)}
                                  </td>

                                  <td className="text-end text-success fw-semibold">
                                    {inr(row.total_paid)}
                                  </td>

                                  <td className="text-end pe-4 text-warning fw-semibold">
                                    {inr(row.total_due)}
                                  </td>
                                  {hasAccess("/batch/fee/report/all/students") && (
                                    <td className="text-end pe-4 text-warning fw-semibold">
                                      <Link
                                        to={`/batch/fee/report/all/students?batch_id=${row.batch_id}`}
                                      >
                                        <i className="ri-eye-line"></i> View
                                      </Link>
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>

                          {!!batchWiseData?.batch_wise?.length && (
                            <tfoot>
                              <tr className="table-light fw-bold">
                                <td className="ps-4"></td>
                                <td className="text-start">Total</td>
                                <td className="text-center">
                                  {batchWiseData.batch_wise.reduce(
                                    (t, b) => t + Number(b.students),
                                    0,
                                  )}
                                </td>
                                <td className="text-end">
                                  {inr(
                                    batchWiseData.batch_wise.reduce(
                                      (t, b) => t + Number(b.total_fee),
                                      0,
                                    ),
                                  )}
                                </td>
                                <td className="text-end">
                                  {inr(
                                    batchWiseData.batch_wise.reduce(
                                      (t, b) => t + Number(b.total_discount),
                                      0,
                                    ),
                                  )}
                                </td>
                                <td className="text-end">
                                  {inr(
                                    batchWiseData.batch_wise.reduce(
                                      (t, b) => t + Number(b.final_fee),
                                      0,
                                    ),
                                  )}
                                </td>
                                <td className="text-end text-success">
                                  {inr(
                                    batchWiseData.batch_wise.reduce(
                                      (t, b) => t + Number(b.total_paid),
                                      0,
                                    ),
                                  )}
                                </td>
                                <td className="text-end pe-4 text-warning">
                                  {inr(
                                    batchWiseData.batch_wise.reduce(
                                      (t, b) => t + Number(b.total_due),
                                      0,
                                    ),
                                  )}
                                </td>
                              </tr>
                            </tfoot>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
